
  import { computed, useContext, useRouter } from '@nuxtjs/composition-api'
  import { useLkAccessGuard } from '@/composables/org/useLkAccessGuard'
  import ButtonDefault from '@/components/main/ui/ButtonDefault.vue'
  import BaseTooltip from '@/components/BaseTooltip.vue'

  const LK_ACCESS_I18N = 'layouts.organization.lk_access'

  export default {
    name: 'LkAccessOverlay',
    components: {
      ButtonDefault,
      BaseTooltip,
    },
    setup() {
      const { i18n } = useContext()
      const router = useRouter()
      const { visible, locked, restore, access, requestRestore } =
        useLkAccessGuard()

      const restoreText = computed(() =>
        i18n.t(
          `${LK_ACCESS_I18N}.${restore.value?.requested ? 'restore_sent' : 'restore'}`
        )
      )

      const goHome = () => {
        router.push('/')
      }

      return {
        visible,
        locked,
        restore,
        access,
        restoreText,
        requestRestore,
        goHome,
      }
    },
  }
